import { createFileRoute, stripSearchParams } from "@tanstack/react-router";
import { PROJECT } from "@/app/capabilities/permissions";
import {
  projectSuggestionsSearchDefaults,
  projectSuggestionsSearchSchema,
} from "@/app/mcp-gateways/suggestions/search-params";
import { SuggestionsPage } from "@/app/mcp-gateways/suggestions/suggestions-page";
import { RouteErrorBoundary } from "@/components/custom/router/route-error-boundary";
import { requireProjectPermission } from "@/lib/route-guards";

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/suggestions"
)({
  validateSearch: projectSuggestionsSearchSchema,
  search: {
    middlewares: [stripSearchParams(projectSuggestionsSearchDefaults)],
  },
  errorComponent: RouteErrorBoundary,
  async beforeLoad(ctx) {
    await requireProjectPermission(ctx, PROJECT.mcpGateways.read);
  },
  loader: () => ({ crumb: "Inbox" }),
  component: SuggestionsPage,
});
